import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { combineLatest, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { SubscriptionList } from '@vendasta/rx-utils';
import { MultiSelectTag, sortTagOptions } from './tag';
import { TagMultiSelectionStoreService } from './tag-multi-selection.service';

@Component({
  selector: 'sales-ui-tag-multi-select',
  templateUrl: './tag-multi-selector.component.html',
  styleUrls: ['./tag-multi-selector.component.scss'],
})
export class TagMultiSelectComponent implements OnDestroy {
  readonly tagOptions$: Observable<MultiSelectTag[]>;
  private readonly subscriptions = SubscriptionList.new();
  readonly formControl: UntypedFormControl = new UntypedFormControl([], []);

  constructor(
    public dialogRef: MatDialogRef<TagMultiSelectComponent>,
    private readonly store: TagMultiSelectionStoreService,
  ) {
    const oppTags$ = this.store.selectableOppTags$;
    const accTags$ = this.store.selectableAccTags$;

    this.tagOptions$ = combineTags(oppTags$, accTags$);

    this.subscriptions.add(
      combineLatest([this.store.selectedOppTags$, this.store.selectedAccountTags$]),
      ([oppTags, accTags]) => {
        this.formControl.setValue(oppTags.concat(accTags));
      },
    );
  }

  compareObjects(x: any, y: any): boolean {
    return !!x && !!y && JSON.stringify(x) === JSON.stringify(y);
  }

  ngOnDestroy(): void {
    this.subscriptions.destroy();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.store.setTagsSelection(this.formControl.value);
    this.dialogRef.close();
  }
}

export function combineTags(
  oppTags$: Observable<MultiSelectTag[]>,
  accTags$: Observable<MultiSelectTag[]>,
): Observable<MultiSelectTag[]> {
  return combineLatest([oppTags$.pipe(startWith([])), accTags$.pipe(startWith([]))]).pipe(
    map(([oppTags, accTags]) => sortTagOptions(oppTags.concat(accTags))),
  );
}
